import { OChainId, TChainId } from 'modules/api';
import { useConnection } from 'modules/auth';

export function useWrongNetwork(expectedChainIds: TChainId[] = []) {
  const { chainId = OChainId.unsupported, isConnected } = useConnection();

  return isConnected && !expectedChainIds.includes(chainId as TChainId);
}
